export function capitalizeFirstLetter(str) {
  return str && str?.length > 0
    ? str.charAt(0).toUpperCase() + str.slice(1)
    : str
}

export function capitalizeAllLetters(str) {
  return str && str?.length > 0
    ? str.toUpperCase()
    : str;
}

export function convertToCustomFormat(str) {
  if (!str || str?.length === 0) {
    return str;
  }
  const words = str.split('_');
  const capitalizedWords = words.map(word =>
    word.charAt(0).toUpperCase() + word.slice(1)
  );
  const result = capitalizedWords.join(' ');
  return result;
}

export function centToDollar(value) {
  return (value / 100).toFixed(2)
}

export function centToDollarString(value, decimalAmount) {
  const dollarAmount = value / 100;
  if (!decimalAmount) return `$${dollarAmount}`;
  return `$${dollarAmount.toFixed(2)}`;
}

export function dollarToCent(value) {
  return value * 100
}

export function toFix(value) {
  var number = Number(value) // change string to number
  return number.toFixed(2)
}